import React from 'react'
import { BusyButton, LogoutButton } from '@ztechapps/webui.button'
import { TextInput } from '@ztechapps/webui.input'
import { Field, Form as FormCore } from '@ztechapps/webui.form'
import { gql } from '@apollo/client'
import { useMutation } from '@ztechapps/common.hook'
import { ButtonGroup } from 'react-bootstrap'

const query = gql(`
  mutation addTenantUser($input: JSON) {
    addTenantUser(input: $input) {
      _id
      status
      profile {
        _id
        name
      }
    }
  }
`)

export const AccountJoinForm = () => {
  const [join, , { loading }] = useMutation({
    query,
    options: { mutationOptions: { refetchQueries: ['allUser', 'singleUser'] } },
  })

  const onSubmit = ({ code }) => {
    const input = {
      code,
    }

    return join({ input })
  }

  const validate = (values) => {
    const errors: any = {}

    if (!values.code) {
      errors.code = 'Required'
    }
    return errors
  }

  return (
    <FormCore onSubmit={onSubmit} initialValues={{ code: '' }} validate={validate}>
      {() => (
        <>
          <div>
            <Field
              component={TextInput}
              name="code"
              label="Organization Code"
              help="Put here the organization code or the invitation code that your organization provided so you can start using the application"
            />
          </div>

          <div className="mt-2 row">
            <ButtonGroup>
              <BusyButton
                icon="users"
                text="Join"
                bsStyle="primary"
                busyText="Submitting"
                isBusy={loading}
                type="submit"
              />
              <LogoutButton text="Back" />
            </ButtonGroup>
          </div>
        </>
      )}
    </FormCore>
  )
}
